import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const ServiceJobTaskTypeUrl = `${Base_Url}/Reports`;

export const GetCustomerReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${ServiceJobTaskTypeUrl}/GetCustomerReport`,
    params
  );
  return res;
};
